/* QUELL — specify-settings: sticky index scroll-spy. Split from theme.js. */
(function () {
  "use strict";
  function ready(fn) {
    if (document.readyState === "loading")
      document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  /* ── Specify settings — sticky index scroll-spy (moved from
     sections/specify-settings.liquid). Re-scoped from #shopify-section-{{id}}
     to the .specify-settings root. */
  function initSpecifySettings(root) {
    if (!root) return;
    var links = Array.prototype.slice.call(
      root.querySelectorAll(".sindex a[href^='#']"),
    );
    var secs = links.map(function (a) {
      return root.querySelector(a.getAttribute("href"));
    });
    if (!("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(
      function (es) {
        es.forEach(function (en) {
          if (!en.isIntersecting) return;
          links.forEach(function (l) {
            l.classList.remove("active");
          });
          var i = secs.indexOf(en.target);
          if (i > -1) links[i].classList.add("active");
        });
      },
      { rootMargin: "-30% 0px -55% 0px" },
    );
    secs.forEach(function (s) {
      if (s) io.observe(s);
    });
  }

  ready(function () {
    document.querySelectorAll(".specify-settings").forEach(function (el) {
      initSpecifySettings(el);
    });
  });
  document.addEventListener("shopify:section:load", function (e) {
    var ss =
      e.target.querySelector && e.target.querySelector(".specify-settings");
    if (ss) {
      initSpecifySettings(ss);
    }
  });
})();
